import { call, select, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionById, getGrusername } from '../selectors';
import type { Action } from 'redux-actions';
import type { ChangeGallectionDescriptionPayload } from '../actions';
import { requestNapi } from '@wix/da-http-client';
import type { PapiRequestDaSharedGallectionFoldersUpdate } from '@wix/da-papi-types';
import { getGallectionType } from '../helpers';

function* setGallectionDescription(
  action: Action<ChangeGallectionDescriptionPayload>
) {
  yield delay(500); // + takeLatest = debounced

  const { folderId, description } = action.payload;
  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    folderId
  );
  const username: ReturnType<typeof getGrusername> =
    yield select(getGrusername);
  if (!gallection) {
    return;
  }

  const params: PapiRequestDaSharedGallectionFoldersUpdate = {
    username,
    type: getGallectionType(gallection) ?? 'collection',
    folderid: gallection.folderId,
    name: gallection.name,
    cover_deviationid:
      gallection.type === 'stash'
        ? undefined
        : get(gallection, 'thumb.deviationId'),
    editorRaw: description,
  };

  yield call(
    requestNapi,
    {
      method: 'post',
      url: 'gallection/folders/update',
      data: params,
    },
    undefined
  );
}

export default setGallectionDescription;
